import { Banner, Text } from '@shopify/polaris'
import { show } from '@intercom/messenger-js-sdk'
import { useTranslation } from 'react-i18next'

interface AppConnectErrorProps {
  errorMessage?: string
}

function AppConnectError({ errorMessage }: AppConnectErrorProps): JSX.Element {
  const { t: translate } = useTranslation()

  return (
    <Banner
      title={translate('Prisync.appConnectError.title')}
      tone="critical"
      action={{
        content: translate('Prisync.appConnectError.action'),
        onAction() {
          show()
        },
      }}
    >
      <Text as="p" variant="bodySm">
        {errorMessage
          ? errorMessage
          : translate('Prisync.appConnectError.message')}
      </Text>
    </Banner>
  )
}

export default AppConnectError
